// import React, { useEffect, useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   Grid,
//   Divider,
//   Avatar,
//   CircularProgress,
//   Alert,
//   Chip,
// } from '@mui/material';
// import {
//   Close,
//   Person,
//   Email,
//   Phone,
//   CalendarToday,
//   Assignment,
//   Business,
//   Campaign,
//   Share,
//   Chat,
// } from '@mui/icons-material';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetOneClientAction } from '../Redux/Actions/UsersAction';
// import moment from 'moment';

// export const LeadDuplicationModal = ({ open, onClose, leadId, leadName }) => {
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);

//   const resselectedlead = useSelector((state) => state.Allusers.Get_users);
//   const leadData = resselectedlead?.data ?? {};

//   const versions = leadData?.allVersions || [];
//   const totalSubmissions = leadData?.totalSubmissions || versions.length;

//   useEffect(() => {
//     if (open && leadId) {
//       setLoading(true);
//       dispatch(GetOneClientAction(leadId)).finally(() => setLoading(false));
//     }
//   }, [dispatch, leadId, open]);

//   const sortedVersions = [...versions].sort(
//     (a, b) => new Date(a.recordedAt) - new Date(b.recordedAt),
//   );

//   const firstSubmission = sortedVersions[0];
//   const lastSubmission = sortedVersions[sortedVersions.length - 1];

//   const getInitials = (name) => {
//     if (!name) return '?';
//     return name
//       .split(' ')
//       .map((n) => n[0])
//       .join('')
//       .toUpperCase()
//       .substring(0, 2);
//   };

//   const InfoRow = ({ icon, label, value }) => (
//     <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//       <Typography variant="body2" sx={{ minWidth: 24, mr: 1 }}>
//         {icon}
//       </Typography>
//       <Typography variant="body2" color="text.secondary" sx={{ minWidth: 80 }}>
//         {label}:
//       </Typography>
//       <Typography variant="body2" fontWeight="medium" sx={{ ml: 1, flex: 1 }}>
//         {value || 'N/A'}
//       </Typography>
//     </Box>
//   );

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="lg"
//       fullWidth
//       sx={{
//         '& .MuiDialog-paper': {
//           borderRadius: '16px',
//           background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
//           overflow: 'hidden',
//           zIndex: '50000',
//           marginTop: '100px',
//         },
//       }}
//     >
//       {/* Header */}
//       <DialogTitle
//         sx={{
//           background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
//           color: 'white',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           py: 2.5,
//           position: 'relative',
//           zIndex: '20000',
//           '&::after': {
//             content: '""',
//             position: 'absolute',
//             bottom: 0,
//             left: 0,
//             right: 0,
//             height: '4px',
//             background: 'linear-gradient(90deg, #10b981 0%, #3b82f6 50%, #8b5cf6 100%)',
//           },
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
//           >
//             📋 Duplicated Submissions
//             <Chip
//               label={`${totalSubmissions} Submission${totalSubmissions !== 1 ? 's' : ''}`}
//               size="small"
//               sx={{
//                 background: 'rgba(255,255,255,0.2)',
//                 color: 'white',
//                 fontWeight: 'bold',
//               }}
//             />
//           </Typography>
//           <Typography variant="subtitle1" sx={{ opacity: 0.9, mt: 0.5 }}>
//             {leadName}
//           </Typography>
//         </Box>
//         <IconButton
//           onClick={onClose}
//           sx={{
//             color: 'white',
//             background: 'rgba(255,255,255,0.1)',
//             '&:hover': {
//               backgroundColor: 'rgba(255,255,255,0.2)',
//             },
//           }}
//         >
//           <Close />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent sx={{ p: 0 }}>
//         {loading ? (
//           <Box
//             sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : versions.length === 0 ? (
//           <Box sx={{ p: 3 }}>
//             <Alert severity="info">No duplicate submissions found for this lead.</Alert>
//           </Box>
//         ) : (
//           <>
//             {/* Summary Section - First & Second Registration */}
//             <Box sx={{ p: 3.5, bgcolor: 'background.default' }}>
//               <Grid container spacing={3}>
//                 {/* First Registration */}
//                 <Grid item xs={12} md={6}>
//                   <Card
//                     sx={{
//                       background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
//                       color: 'white',
//                       border: 'none',
//                       borderRadius: '12px',
//                       boxShadow: '0 8px 25px rgba(16, 185, 129, 0.3)',
//                       position: 'relative',
//                       overflow: 'visible',
//                       '&::before': {
//                         content: '"FIRST"',
//                         position: 'absolute',
//                         top: -10,
//                         left: 20,
//                         background: '#065f46',
//                         color: 'white',
//                         fontSize: '12px',
//                         fontWeight: 'bold',
//                         padding: '4px 12px',
//                         borderRadius: '20px',
//                         boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
//                       },
//                     }}
//                   >
//                     <CardContent sx={{ p: 2.5 }}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                         <Avatar
//                           sx={{
//                             bgcolor: 'rgba(255,255,255,0.2)',
//                             mr: 2,
//                             width: 48,
//                             height: 48,
//                             border: '2px solid rgba(255,255,255,0.3)',
//                           }}
//                         >
//                           <CalendarToday sx={{ fontSize: 24 }} />
//                         </Avatar>
//                         <Box>
//                           <Typography variant="h6" fontWeight="bold">
//                             First Registration
//                           </Typography>
//                           <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                             Initial Submission
//                           </Typography>
//                         </Box>
//                       </Box>

//                       <Box sx={{ space: 0.5 }}>
//                         <InfoRow
//                           icon="👤"
//                           label="By"
//                           value={firstSubmission?.addby?.name || 'N/A'}
//                           sx={{ color: 'white' }}
//                         />
//                         <InfoRow
//                           icon="📅"
//                           label="Date"
//                           value={
//                             firstSubmission
//                               ? moment(firstSubmission.recordedAt).format('DD MMM YYYY, HH:mm')
//                               : 'N/A'
//                           }
//                         />
//                         <InfoRow icon="🆔" label="Version" value={`#1 of ${totalSubmissions}`} />
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 </Grid>

//                 {/* Last Registration */}
//                 <Grid item xs={12} md={6}>
//                   <Card
//                     sx={{
//                       background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
//                       color: 'white',
//                       border: 'none',
//                       borderRadius: '12px',
//                       boxShadow: '0 8px 25px rgba(245, 158, 11, 0.3)',
//                       position: 'relative',
//                       overflow: 'visible',
//                       '&::before': {
//                         content: '"LAST"',
//                         position: 'absolute',
//                         top: -10,
//                         left: 20,
//                         background: '#92400e',
//                         color: 'white',
//                         fontSize: '12px',
//                         fontWeight: 'bold',
//                         padding: '4px 12px',
//                         borderRadius: '20px',
//                         boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
//                       },
//                     }}
//                   >
//                     <CardContent sx={{ p: 2.5 }}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                         <Avatar
//                           sx={{
//                             bgcolor: 'rgba(255,255,255,0.2)',
//                             mr: 2,
//                             width: 48,
//                             height: 48,
//                             border: '2px solid rgba(255,255,255,0.3)',
//                           }}
//                         >
//                           <Campaign sx={{ fontSize: 24 }} />
//                         </Avatar>
//                         <Box>
//                           <Typography variant="h6" fontWeight="bold">
//                             Last Registration
//                           </Typography>
//                           <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                             Most Recent Submission
//                           </Typography>
//                         </Box>
//                       </Box>

//                       <Box sx={{ space: 0.5 }}>
//                         <InfoRow
//                           icon="👤"
//                           label="By"
//                           value={lastSubmission?.addby?.name || 'N/A'}
//                         />
//                         <InfoRow
//                           icon="📅"
//                           label="Date"
//                           value={
//                             lastSubmission
//                               ? moment(lastSubmission.recordedAt).format('DD MMM YYYY, HH:mm')
//                               : 'N/A'
//                           }
//                         />
//                         <InfoRow
//                           icon="🆔"
//                           label="Version"
//                           value={`#${totalSubmissions} of ${totalSubmissions}`}
//                         />
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               </Grid>
//             </Box>

//             <Divider sx={{ borderColor: '#e2e8f0' }} />

//             {/* Submissions Grid */}
//             <Box sx={{ p: 3, maxHeight: '60vh', overflow: 'auto', background: '#f8fafc' }}>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   mb: 3,
//                   color: '#374151',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 1,
//                 }}
//               >
//                 📊 All Submissions ({totalSubmissions})
//               </Typography>

//               <Grid container spacing={3}>
//                 {sortedVersions.map((ver, index) => {
//                   const isFirst = index === 0;
//                   const isLast = index === sortedVersions.length - 1;

//                   return (
//                     <Grid item xs={12} md={6} lg={4} key={index}>
//                       <Card
//                         sx={{
//                           height: '100%',
//                           background: 'white',
//                           border: `2px solid ${
//                             isFirst ? '#10b981' : isLast ? '#f59e0b' : '#e2e8f0'
//                           }`,
//                           borderRadius: '12px',
//                           transition: 'all 0.3s ease',
//                           position: 'relative',
//                           overflow: 'visible',
//                           '&:hover': {
//                             transform: 'translateY(-6px)',
//                             boxShadow: '0 12px 35px rgba(0,0,0,0.15)',
//                           },
//                         }}
//                       >
//                         {/* Badge for first/last */}
//                         {(isFirst || isLast) && (
//                           <Chip
//                             label={isFirst ? 'FIRST' : 'LAST'}
//                             size="small"
//                             sx={{
//                               position: 'absolute',
//                               top: -10,
//                               right: 16,
//                               background: isFirst ? '#10b981' : '#f59e0b',
//                               color: 'white',
//                               fontWeight: 'bold',
//                               fontSize: '10px',
//                               height: '20px',
//                             }}
//                           />
//                         )}

//                         <CardContent sx={{ p: 2.5 }}>
//                           {/* Header */}
//                           <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
//                             <Avatar
//                               sx={{
//                                 bgcolor: isFirst ? '#10b981' : isLast ? '#f59e0b' : '#6366f1',
//                                 mr: 2,
//                                 width: 44,
//                                 height: 44,
//                                 fontWeight: 'bold',
//                                 border: `2px solid ${
//                                   isFirst ? '#10b98133' : isLast ? '#f59e0b33' : '#6366f133'
//                                 }`,
//                               }}
//                             >
//                               {getInitials(ver.addby?.name)}
//                             </Avatar>
//                             <Box sx={{ flex: 1 }}>
//                               <Typography variant="h6" fontWeight="bold" color="primary">
//                                 Submission #{index + 1}
//                               </Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 {moment(ver.recordedAt).format('DD MMM YYYY, HH:mm')}
//                               </Typography>
//                             </Box>
//                           </Box>

//                           {/* Content */}
//                           <Box sx={{ space: 1 }}>
//                             <InfoRow icon="👤" label="Name" value={ver.name} />
//                             <InfoRow icon="📧" label="Email" value={ver.email} />
//                             <InfoRow icon="📞" label="Phone" value={ver.phone} />
//                             <InfoRow
//                               icon="📞"
//                               label="Phone2"
//                               value={ver.phonenumber2 || 'Not Exist'}
//                             />
//                             <InfoRow
//                               icon="📞"
//                               label="WhatsApp"
//                               value={ver.whatsappnumber || 'Not Exist'}
//                             />

//                             <InfoRow icon="🏢" label="Project" value={ver.project?.name} />
//                             <InfoRow
//                               icon="🏗️"
//                               label="Developer"
//                               value={ver.project?.developer?.name}
//                             />
//                             <InfoRow icon="🎯" label="Campaign" value={ver.campaign?.CampainName} />
//                             {/* Channel و Communication Way */}
//                             <InfoRow
//                               icon="📡"
//                               label="Channel"
//                               value={ver.chanel?.name || 'Not Specified'}
//                             />
//                             <InfoRow
//                               icon="💬"
//                               label="Communication"
//                               value={ver.communicationway?.name || 'Not Specified'}
//                             />
//                             {/* Added By */}
//                             <Box
//                               sx={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 mt: 2,
//                                 pt: 2,
//                                 borderTop: '1px solid #f1f5f9',
//                               }}
//                             >
//                               <Assignment sx={{ fontSize: 16, mr: 1, color: 'text.secondary' }} />
//                               <Typography variant="caption" color="text.secondary">
//                                 Added by:{' '}
//                                 <strong style={{ color: '#374151' }}>
//                                   {ver.addby?.name || 'N/A'}
//                                 </strong>
//                               </Typography>
//                             </Box>
//                           </Box>
//                         </CardContent>
//                       </Card>
//                     </Grid>
//                   );
//                 })}
//               </Grid>
//             </Box>
//           </>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// };

















// 20-5-2026
// import React, { useEffect, useState } from 'react';
// import { createPortal } from 'react-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetOneClientAction } from '../Redux/Actions/UsersAction';
// import moment from 'moment';

// /* ─── inline CSS ─────────────────────────────────────────────────────────── */
// const STYLES = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');

//   @keyframes ldm-in {
//     from { opacity:0; transform:translateY(18px) scale(0.98); }
//     to   { opacity:1; transform:none; }
//   }
//   @keyframes ldm-spin { to { transform:rotate(360deg); } }

//   .ldm-overlay {
//     position:fixed; inset:0; z-index:99999;
//     display:flex; align-items:center; justify-content:center;
//     background:rgba(15,23,42,0.5);
//     backdrop-filter:blur(6px);
//     padding:20px;
//     font-family:'DM Sans',sans-serif;
//   }

//   .ldm-modal {
//     background:#F8FAFC;
//     border-radius:16px;
//     width:100%; max-width:900px;
//     max-height:92vh;
//     overflow:hidden;
//     display:flex; flex-direction:column;
//     box-shadow:0 32px 80px rgba(0,0,0,0.2);
//     animation:ldm-in 0.3s cubic-bezier(0.34,1.1,0.64,1) both;
//     border:1px solid #E2E8F0;
//   }

//   /* ── header ── */
//   .ldm-header {
//     background:#fff;
//     padding:20px 28px 18px;
//     border-bottom:1px solid #E9EEF5;
//     flex-shrink:0;
//     display:flex; align-items:flex-start; justify-content:space-between;
//   }
//   .ldm-audit-label {
//     font-size:10px; font-weight:700; letter-spacing:0.12em;
//     color:#94A3B8; text-transform:uppercase; margin-bottom:4px;
//   }
//   .ldm-title {
//     font-size:24px; font-weight:800; color:#0F172A;
//     letter-spacing:-0.4px; margin:0;
//   }
//   .ldm-count-badge {
//     display:flex; align-items:center; gap:7px;
//     background:#F1F5F9; border:1.5px solid #E2E8F0;
//     padding:8px 14px; border-radius:10px;
//     font-size:13px; font-weight:700; color:#475569;
//     flex-shrink:0;
//   }
//   .ldm-close {
//     width:34px; height:34px; border-radius:8px;
//     border:1.5px solid #E2E8F0; background:#F8FAFC;
//     display:flex; align-items:center; justify-content:center;
//     cursor:pointer; color:#64748B; margin-left:12px;
//     transition:all 0.15s; flex-shrink:0;
//   }
//   .ldm-close:hover { background:#F1F5F9; color:#0F172A; }

//   /* ── top cards ── */
//   .ldm-cards-row {
//     display:grid; grid-template-columns:1fr 1fr; gap:16px;
//     padding:20px 28px 0; flex-shrink:0;
//   }
//   .ldm-card {
//     background:#fff; border-radius:12px;
//     border:1.5px solid #E2E8F0;
//     padding:18px 20px;
//     position:relative; overflow:hidden;
//   }
//   .ldm-card.first { border-left:4px solid #22C55E; }
//   .ldm-card.last  { border-left:4px solid #F59E0B; }

//   .ldm-card-badge {
//     position:absolute; top:14px; right:14px;
//     padding:3px 10px; border-radius:20px;
//     font-size:10px; font-weight:700; letter-spacing:0.08em;
//   }
//   .ldm-card-badge.original  { background:#DCFCE7; color:#16A34A; }
//   .ldm-card-badge.duplicate { background:#FEF3C7; color:#D97706; }

//   .ldm-card-title {
//     font-size:15px; font-weight:700; color:#0F172A; margin:0 0 14px;
//   }
//   .ldm-card-grid {
//     display:grid; grid-template-columns:1fr 1fr; gap:10px 20px;
//   }
//   .ldm-card-field-label {
//     font-size:10px; font-weight:700; letter-spacing:0.08em;
//     color:#94A3B8; text-transform:uppercase; margin-bottom:3px;
//   }
//   .ldm-card-field-value {
//     font-size:13px; font-weight:600; color:#1E293B;
//   }

//   /* ── divider ── */
//   .ldm-divider { height:1px; background:#E9EEF5; margin:20px 28px 0; flex-shrink:0; }

//   /* ── table section ── */
//   .ldm-table-section {
//     flex:1; overflow-y:auto; padding:0 28px 24px;
//     scrollbar-width:thin; scrollbar-color:#CBD5E1 transparent;
//   }
//   .ldm-table-section::-webkit-scrollbar { width:5px; }
//   .ldm-table-section::-webkit-scrollbar-thumb { background:#CBD5E1; border-radius:4px; }

//   .ldm-table {
//     width:100%; border-collapse:collapse; margin-top:20px;
//     background:#fff; border-radius:12px; overflow:hidden;
//     border:1.5px solid #E2E8F0;
//   }

//   /* thead */
//   .ldm-table thead tr {
//     background:#F8FAFC;
//     border-bottom:1.5px solid #E2E8F0;
//   }
//   .ldm-th {
//     padding:11px 16px; text-align:left;
//     font-size:10.5px; font-weight:700; letter-spacing:0.08em;
//     text-transform:uppercase; white-space:nowrap;
//   }
//   .ldm-th.attr  { color:#94A3B8; width:160px; }
//   .ldm-th.sub   { color:#4F46E5; }

//   /* tbody */
//   .ldm-tr { border-bottom:1px solid #F1F5F9; transition:background 0.1s; }
//   .ldm-tr:last-child { border-bottom:none; }
//   .ldm-tr:hover { background:#FAFBFF; }

//   .ldm-td {
//     padding:13px 16px; vertical-align:middle;
//   }
//   .ldm-td.attr-cell {
//     display:flex; align-items:center; gap:10px;
//     font-size:13px; font-weight:600; color:#374151;
//   }
//   .ldm-td-icon {
//     width:28px; height:28px; border-radius:7px;
//     background:#F1F5F9; display:flex; align-items:center;
//     justify-content:center; flex-shrink:0; color:#64748B;
//   }
//   .ldm-td-val {
//     font-size:13px; color:#0F172A; font-weight:400;
//   }
//   .ldm-td-val.italic { color:#64748B; font-style:italic; }
//   .ldm-td-val.diff   { font-weight:600; }

//   /* campaign badge */
//   .ldm-campaign-badge {
//     display:inline-block; padding:3px 10px; border-radius:20px;
//     font-size:11px; font-weight:700; letter-spacing:0.04em;
//     background:#EDE9FE; color:#7C3AED;
//   }
//   .ldm-campaign-badge.b { background:#DBEAFE; color:#1D4ED8; }

//   /* ── footer ── */
//   .ldm-footer {
//     padding:14px 28px; border-top:1px solid #E9EEF5;
//     display:flex; align-items:center; justify-content:flex-end;
//     gap:10px; flex-shrink:0; background:#fff;
//   }
//   .ldm-btn-ignore {
//     padding:10px 22px; border-radius:10px;
//     border:1.5px solid #E2E8F0; background:#fff;
//     font-family:'DM Sans',sans-serif; font-size:14px; font-weight:600;
//     color:#64748B; cursor:pointer; transition:all 0.15s;
//   }
//   .ldm-btn-ignore:hover { background:#F8FAFC; border-color:#CBD5E1; color:#0F172A; }
//   .ldm-btn-merge {
//     padding:10px 28px; border-radius:10px; border:none;
//     background:#1E3A8A; color:#fff;
//     font-family:'DM Sans',sans-serif; font-size:14px; font-weight:700;
//     cursor:pointer; transition:all 0.15s;
//   }
//   .ldm-btn-merge:hover { background:#1E40AF; }

//   /* loading / empty */
//   .ldm-center {
//     display:flex; flex-direction:column; align-items:center;
//     justify-content:center; padding:60px 20px;
//     color:#94A3B8; font-size:14px; gap:12px;
//   }
//   .ldm-spinner {
//     width:36px; height:36px; border:3px solid #E2E8F0;
//     border-top-color:#4F46E5; border-radius:50%;
//     animation:ldm-spin 0.7s linear infinite;
//   }
// `;

// /* ─── icons ──────────────────────────────────────────────────────────────── */
// const IcoClose  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
// const IcoList   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;
// const IcoUser   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
// const IcoMail   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
// const IcoPhone  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.07 6.07l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
// const IcoWa     = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/></svg>;
// const IcoBuild  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9.5L12 3l9 6.5V21H3V9.5z"/><rect x="9" y="14" width="6" height="7" rx="1"/></svg>;
// const IcoHammer = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15.2 2.8L21 8.6l-9 9-5.8-5.8z"/><path d="M6.5 17.5l-4 4"/><path d="M2 12l5-5"/></svg>;
// const IcoMega   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>;
// const IcoSignal = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="1" y1="6" x2="1" y2="18"/><line x1="6" y1="3" x2="6" y2="18"/><line x1="11" y1="8" x2="11" y2="18"/><line x1="16" y1="5" x2="16" y2="18"/></svg>;
// const IcoChat   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;

// /* ─── field config ───────────────────────────────────────────────────────── */
// const FIELDS = [
//   { key:'name',           label:'Name',             icon:<IcoUser/>,   get: v => v.name },
//   { key:'email',          label:'Email Address',     icon:<IcoMail/>,   get: v => v.email },
//   { key:'phone',          label:'Phone',             icon:<IcoPhone/>,  get: v => v.phone },
//   { key:'whatsapp',       label:'WhatsApp',          icon:<IcoWa/>,     get: v => v.whatsappnumber },
//   { key:'project',        label:'Project',           icon:<IcoBuild/>,  get: v => v.project?.name },
//   { key:'developer',      label:'Developer',         icon:<IcoHammer/>, get: v => v.project?.developer?.name },
//   { key:'campaign',       label:'Campaign',          icon:<IcoMega/>,   get: v => v.campaign?.CampainName, isCampaign: true },
//   { key:'channel',        label:'Channel',           icon:<IcoSignal/>, get: v => v.chanel?.name },
//   { key:'communication',  label:'Communication Way', icon:<IcoChat/>,   get: v => v.communicationway?.name },
// ];

// /* ════════════════════════════════════════════════════════════════════════════
//    COMPONENT
// ════════════════════════════════════════════════════════════════════════════ */
// export const LeadDuplicationModal = ({ open, onClose, leadId, leadName }) => {
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);

//   const resselectedlead  = useSelector(s => s.Allusers.Get_users);
//   const leadData         = resselectedlead?.data ?? {};
//   const versions         = leadData?.allVersions || [];
//   const totalSubmissions = leadData?.totalSubmissions || versions.length;

//   useEffect(() => {
//     if (open && leadId) {
//       setLoading(true);
//       dispatch(GetOneClientAction(leadId)).finally(() => setLoading(false));
//     }
//   }, [dispatch, leadId, open]);

//   const sortedVersions  = [...versions].sort((a, b) => new Date(a.recordedAt) - new Date(b.recordedAt));
//   const firstSubmission = sortedVersions[0];
//   const lastSubmission  = sortedVersions[sortedVersions.length - 1];

//   if (!open) return null;

//   return createPortal(
//     <>
//       <style>{STYLES}</style>
//       <div className="ldm-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
//         <div className="ldm-modal">

//           {/* ── Header ── */}
//           <div className="ldm-header">
//             <div style={{ flex:1 }}>
//               <div className="ldm-audit-label">Audit Registry</div>
//               <h2 className="ldm-title">Duplicated Submissions</h2>
//             </div>
//             <div className="ldm-count-badge">
//               <IcoList />
//               {totalSubmissions} Submission{totalSubmissions !== 1 ? 's' : ''} Found
//             </div>
//             <button className="ldm-close" onClick={onClose}><IcoClose /></button>
//           </div>

//           {loading ? (
//             <div className="ldm-center">
//               <div className="ldm-spinner" />
//               <span>Loading submissions…</span>
//             </div>
//           ) : versions.length === 0 ? (
//             <div className="ldm-center">
//               <span style={{ fontSize:32 }}>📭</span>
//               <span>No duplicate submissions found for this lead.</span>
//             </div>
//           ) : (
//             <>
//               {/* ── Top Cards ── */}
//               <div className="ldm-cards-row">
//                 {/* First Registration */}
//                 <div className="ldm-card first">
//                   <span className="ldm-card-badge original">ORIGINAL</span>
//                   <p className="ldm-card-title">First Registration</p>
//                   <div className="ldm-card-grid">
//                     <div>
//                       <div className="ldm-card-field-label">Created By</div>
//                       <div className="ldm-card-field-value">{firstSubmission?.addby?.name || 'N/A'}</div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">Registry Date</div>
//                       <div className="ldm-card-field-value">
//                         {firstSubmission ? moment(firstSubmission.recordedAt).format('MMM DD, YYYY · hh:mm A') : 'N/A'}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">System Version</div>
//                       <div className="ldm-card-field-value" style={{ color:'#22C55E', fontWeight:700 }}>
//                         #1 of {totalSubmissions}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">Source ID</div>
//                       <div className="ldm-card-field-value" style={{ color:'#64748B' }}>
//                         #{firstSubmission?._id?.slice(-6)?.toUpperCase() || 'N/A'}
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Last Registration */}
//                 <div className="ldm-card last">
//                   <span className="ldm-card-badge duplicate">DUPLICATE</span>
//                   <p className="ldm-card-title">Last Registration</p>
//                   <div className="ldm-card-grid">
//                     <div>
//                       <div className="ldm-card-field-label">Created By</div>
//                       <div className="ldm-card-field-value">{lastSubmission?.addby?.name || 'N/A'}</div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">Registry Date</div>
//                       <div className="ldm-card-field-value">
//                         {lastSubmission ? moment(lastSubmission.recordedAt).format('MMM DD, YYYY · hh:mm A') : 'N/A'}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">System Version</div>
//                       <div className="ldm-card-field-value" style={{ color:'#F59E0B', fontWeight:700 }}>
//                         #{totalSubmissions} of {totalSubmissions}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">Source ID</div>
//                       <div className="ldm-card-field-value" style={{ color:'#64748B' }}>
//                         #{lastSubmission?._id?.slice(-6)?.toUpperCase() || 'N/A'}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* ── Divider ── */}
//               <div className="ldm-divider" />

//               {/* ── Comparison Table ── */}
//               <div className="ldm-table-section">
//                 <table className="ldm-table">
//                   <thead>
//                     <tr>
//                       <th className="ldm-th attr">Attribute Field</th>
//                       {sortedVersions.map((_, i) => (
//                         <th key={i} className="ldm-th sub">
//                           Submission #{i + 1}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {FIELDS.map(field => {
//                       const vals = sortedVersions.map(v => field.get(v));
//                       const allSame = vals.every(v => v === vals[0]);
//                       return (
//                         <tr key={field.key} className="ldm-tr">
//                           {/* Attribute */}
//                           <td className="ldm-td">
//                             <div className="ldm-td.attr-cell" style={{ display:'flex', alignItems:'center', gap:10 }}>
//                               <div className="ldm-td-icon">{field.icon}</div>
//                               <span style={{ fontSize:13, fontWeight:600, color:'#374151' }}>{field.label}</span>
//                             </div>
//                           </td>
//                           {/* Values per submission */}
//                           {vals.map((val, i) => (
//                             <td key={i} className="ldm-td">
//                               {field.isCampaign && val ? (
//                                 <span className={`ldm-campaign-badge ${i % 2 === 1 ? 'b' : ''}`}>
//                                   {val.toUpperCase()}
//                                 </span>
//                               ) : (
//                                 <span className={`ldm-td-val ${!val ? 'italic' : ''} ${!allSame ? 'diff' : ''}`}>
//                                   {val || 'Not Specified'}
//                                 </span>
//                               )}
//                             </td>
//                           ))}
//                         </tr>
//                       );
//                     })}

//                     {/* Added By row */}
//                     <tr className="ldm-tr" style={{ background:'#FAFBFF' }}>
//                       <td className="ldm-td">
//                         <div style={{ display:'flex', alignItems:'center', gap:10 }}>
//                           <div className="ldm-td-icon"><IcoUser /></div>
//                           <span style={{ fontSize:13, fontWeight:600, color:'#374151' }}>Added By</span>
//                         </div>
//                       </td>
//                       {sortedVersions.map((ver, i) => (
//                         <td key={i} className="ldm-td">
//                           <span style={{ fontSize:13, fontWeight:600, color:'#4F46E5' }}>
//                             {ver.addby?.name || 'N/A'}
//                           </span>
//                         </td>
//                       ))}
//                     </tr>

//                     {/* Date row */}
//                     <tr className="ldm-tr" style={{ background:'#FAFBFF' }}>
//                       <td className="ldm-td">
//                         <div style={{ display:'flex', alignItems:'center', gap:10 }}>
//                           <div className="ldm-td-icon">
//                             <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
//                           </div>
//                           <span style={{ fontSize:13, fontWeight:600, color:'#374151' }}>Recorded At</span>
//                         </div>
//                       </td>
//                       {sortedVersions.map((ver, i) => (
//                         <td key={i} className="ldm-td">
//                           <span style={{ fontSize:13, color:'#64748B' }}>
//                             {ver.recordedAt ? moment(ver.recordedAt).format('DD MMM YYYY, HH:mm') : 'N/A'}
//                           </span>
//                         </td>
//                       ))}
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               {/* ── Footer ── */}
//               <div className="ldm-footer">
//                 <button className="ldm-btn-ignore" onClick={onClose}>Ignore Duplicates</button>
//                 {/* <button className="ldm-btn-merge" onClick={onClose}>Merge Records</button> */}
//               </div>
//             </>
//           )}

//         </div>
//       </div>
//     </>,
//     document.body
//   );
// };
























// after 205-5-2026
// import React, { useEffect, useState } from 'react';
// import { createPortal } from 'react-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetOneClientAction, UpdateClientAction } from '../Redux/Actions/UsersAction';
// import moment from 'moment';

// /* ─── inline CSS ─────────────────────────────────────────────────────────── */
// const STYLES = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');

//   @keyframes ldm-in {
//     from { opacity:0; transform:translateY(18px) scale(0.98); }
//     to   { opacity:1; transform:none; }
//   }
//   @keyframes ldm-spin { to { transform:rotate(360deg); } }

//   .ldm-overlay {
//     position:fixed; inset:0; z-index:99999;
//     display:flex; align-items:center; justify-content:center;
//     background:rgba(15,23,42,0.5);
//     backdrop-filter:blur(6px);
//     padding:20px;
//     font-family:'DM Sans',sans-serif;
//   }

//   .ldm-modal {
//     background:#F8FAFC;
//     border-radius:16px;
//     width:100%; max-width:900px;
//     max-height:92vh;
//     overflow:hidden;
//     display:flex; flex-direction:column;
//     box-shadow:0 32px 80px rgba(0,0,0,0.2);
//     animation:ldm-in 0.3s cubic-bezier(0.34,1.1,0.64,1) both;
//     border:1px solid #E2E8F0;
//   }

//   .ldm-header {
//     background:#fff;
//     padding:20px 28px 18px;
//     border-bottom:1px solid #E9EEF5;
//     flex-shrink:0;
//     display:flex; align-items:flex-start; justify-content:space-between;
//   }
//   .ldm-audit-label {
//     font-size:10px; font-weight:700; letter-spacing:0.12em;
//     color:#94A3B8; text-transform:uppercase; margin-bottom:4px;
//   }
//   .ldm-title {
//     font-size:24px; font-weight:800; color:#0F172A;
//     letter-spacing:-0.4px; margin:0;
//   }
//   .ldm-count-badge {
//     display:flex; align-items:center; gap:7px;
//     background:#F1F5F9; border:1.5px solid #E2E8F0;
//     padding:8px 14px; border-radius:10px;
//     font-size:13px; font-weight:700; color:#475569;
//     flex-shrink:0;
//   }
//   .ldm-close {
//     width:34px; height:34px; border-radius:8px;
//     border:1.5px solid #E2E8F0; background:#F8FAFC;
//     display:flex; align-items:center; justify-content:center;
//     cursor:pointer; color:#64748B; margin-left:12px;
//     transition:all 0.15s; flex-shrink:0;
//   }
//   .ldm-close:hover { background:#F1F5F9; color:#0F172A; }

//   .ldm-cards-row {
//     display:grid; grid-template-columns:1fr 1fr; gap:16px;
//     padding:20px 28px 0; flex-shrink:0;
//   }
//   .ldm-card {
//     background:#fff; border-radius:12px;
//     border:1.5px solid #E2E8F0;
//     padding:18px 20px;
//     position:relative; overflow:hidden;
//   }
//   .ldm-card.first { border-left:4px solid #22C55E; }
//   .ldm-card.last  { border-left:4px solid #F59E0B; }

//   .ldm-card-badge {
//     position:absolute; top:14px; right:14px;
//     padding:3px 10px; border-radius:20px;
//     font-size:10px; font-weight:700; letter-spacing:0.08em;
//   }
//   .ldm-card-badge.original  { background:#DCFCE7; color:#16A34A; }
//   .ldm-card-badge.duplicate { background:#FEF3C7; color:#D97706; }

//   .ldm-card-title {
//     font-size:15px; font-weight:700; color:#0F172A; margin:0 0 14px;
//   }
//   .ldm-card-grid {
//     display:grid; grid-template-columns:1fr 1fr; gap:10px 20px;
//   }
//   .ldm-card-field-label {
//     font-size:10px; font-weight:700; letter-spacing:0.08em;
//     color:#94A3B8; text-transform:uppercase; margin-bottom:3px;
//   }
//   .ldm-card-field-value {
//     font-size:13px; font-weight:600; color:#1E293B;
//   }

//   .ldm-divider { height:1px; background:#E9EEF5; margin:20px 28px 0; flex-shrink:0; }

//   .ldm-table-section {
//     flex:1; overflow-y:auto; padding:0 28px 24px;
//     scrollbar-width:thin; scrollbar-color:#CBD5E1 transparent;
//   }
//   .ldm-table-section::-webkit-scrollbar { width:5px; }
//   .ldm-table-section::-webkit-scrollbar-thumb { background:#CBD5E1; border-radius:4px; }

//   .ldm-table {
//     width:100%; border-collapse:collapse; margin-top:20px;
//     background:#fff; border-radius:12px; overflow:hidden;
//     border:1.5px solid #E2E8F0;
//   }

//   .ldm-table thead tr {
//     background:#F8FAFC;
//     border-bottom:1.5px solid #E2E8F0;
//   }
//   .ldm-th {
//     padding:11px 16px; text-align:left;
//     font-size:10.5px; font-weight:700; letter-spacing:0.08em;
//     text-transform:uppercase; white-space:nowrap;
//   }
//   .ldm-th.attr  { color:#94A3B8; width:160px; }
//   .ldm-th.sub   { color:#4F46E5; }

//   .ldm-tr { border-bottom:1px solid #F1F5F9; transition:background 0.1s; }
//   .ldm-tr:last-child { border-bottom:none; }
//   .ldm-tr:hover { background:#FAFBFF; }

//   .ldm-td {
//     padding:13px 16px; vertical-align:middle;
//   }
//   .ldm-td-icon {
//     width:28px; height:28px; border-radius:7px;
//     background:#F1F5F9; display:flex; align-items:center;
//     justify-content:center; flex-shrink:0; color:#64748B;
//   }
//   .ldm-td-val {
//     font-size:13px; color:#0F172A; font-weight:400;
//   }
//   .ldm-td-val.italic { color:#64748B; font-style:italic; }
//   .ldm-td-val.diff   { font-weight:600; }

//   .ldm-campaign-badge {
//     display:inline-block; padding:3px 10px; border-radius:20px;
//     font-size:11px; font-weight:700; letter-spacing:0.04em;
//     background:#EDE9FE; color:#7C3AED;
//   }
//   .ldm-campaign-badge.b { background:#DBEAFE; color:#1D4ED8; }

//   /* ── plus button ── */
//   .ldm-plus-btn {
//     width:22px; height:22px; border-radius:50%;
//     border:1.5px solid #CBD5E1; background:#F8FAFC;
//     display:inline-flex; align-items:center; justify-content:center;
//     cursor:pointer; color:#64748B; margin-left:8px;
//     transition:all 0.15s; flex-shrink:0; vertical-align:middle;
//     font-size:16px; font-weight:700; line-height:1;
//   }
//   .ldm-plus-btn:hover { background:#EFF6FF; border-color:#3B82F6; color:#3B82F6; }

//   /* ── confirm popup ── */
//   .ldm-edit-popup {
//     position:fixed; z-index:100000;
//     background:#fff; border-radius:12px;
//     border:1.5px solid #E2E8F0;
//     box-shadow:0 8px 32px rgba(0,0,0,0.15);
//     padding:16px 18px;
//     min-width:300px;
//     animation:ldm-in 0.2s ease both;
//   }
//   .ldm-edit-popup-title {
//     font-size:11px; font-weight:700; letter-spacing:0.08em;
//     color:#64748B; text-transform:uppercase; margin-bottom:10px;
//   }
//   .ldm-edit-actions {
//     display:flex; gap:8px; margin-top:12px; justify-content:flex-end;
//   }
//   .ldm-edit-cancel {
//     padding:6px 14px; border-radius:7px;
//     border:1.5px solid #E2E8F0; background:#fff;
//     font-family:'DM Sans',sans-serif; font-size:12px; font-weight:600;
//     color:#64748B; cursor:pointer;
//   }
//   .ldm-edit-save {
//     padding:6px 16px; border-radius:7px; border:none;
//     background:#1E3A8A; color:#fff;
//     font-family:'DM Sans',sans-serif; font-size:12px; font-weight:700;
//     cursor:pointer; transition:background 0.15s;
//     display:flex; align-items:center; gap:6px;
//   }
//   .ldm-edit-save:hover { background:#1E40AF; }
//   .ldm-edit-save:disabled { opacity:0.55; cursor:not-allowed; }
//   .ldm-spinner-sm {
//     width:12px; height:12px; border:2px solid rgba(255,255,255,0.3);
//     border-top-color:#fff; border-radius:50%;
//     animation:ldm-spin 0.7s linear infinite;
//   }

//   .ldm-footer {
//     padding:14px 28px; border-top:1px solid #E9EEF5;
//     display:flex; align-items:center; justify-content:flex-end;
//     gap:10px; flex-shrink:0; background:#fff;
//   }
//   .ldm-btn-ignore {
//     padding:10px 22px; border-radius:10px;
//     border:1.5px solid #E2E8F0; background:#fff;
//     font-family:'DM Sans',sans-serif; font-size:14px; font-weight:600;
//     color:#64748B; cursor:pointer; transition:all 0.15s;
//   }
//   .ldm-btn-ignore:hover { background:#F8FAFC; border-color:#CBD5E1; color:#0F172A; }

//   .ldm-center {
//     display:flex; flex-direction:column; align-items:center;
//     justify-content:center; padding:60px 20px;
//     color:#94A3B8; font-size:14px; gap:12px;
//   }
//   .ldm-spinner {
//     width:36px; height:36px; border:3px solid #E2E8F0;
//     border-top-color:#4F46E5; border-radius:50%;
//     animation:ldm-spin 0.7s linear infinite;
//   }
// `;

// /* ─── icons ──────────────────────────────────────────────────────────────── */
// const IcoClose  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
// const IcoList   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;
// const IcoUser   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
// const IcoMail   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
// const IcoPhone  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.07 6.07l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
// const IcoWa     = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/></svg>;
// const IcoBuild  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9.5L12 3l9 6.5V21H3V9.5z"/><rect x="9" y="14" width="6" height="7" rx="1"/></svg>;
// const IcoHammer = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15.2 2.8L21 8.6l-9 9-5.8-5.8z"/><path d="M6.5 17.5l-4 4"/><path d="M2 12l5-5"/></svg>;
// const IcoMega   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>;
// const IcoSignal = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="1" y1="6" x2="1" y2="18"/><line x1="6" y1="3" x2="6" y2="18"/><line x1="11" y1="8" x2="11" y2="18"/><line x1="16" y1="5" x2="16" y2="18"/></svg>;
// const IcoChat   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;

// /* ─── field config ───────────────────────────────────────────────────────── */
// // editable: true → هيظهر + button جنب كل قيمة في كل submition
// // fieldKey: اسم الـ key اللي هيتعمل عليه update في الـ API
// const FIELDS = [
//   { key:'name',           label:'Name',             icon:<IcoUser/>,   get: v => v.name,                      editable:true,  fieldKey:'name'         },
//   { key:'email',          label:'Email',            icon:<IcoMail/>,   get: v => v.email,                     editable:true,  fieldKey:'email'        },
//   { key:'phone',          label:'Phone',            icon:<IcoPhone/>,  get: v => v.phone,                     editable:true,  fieldKey:'phone'        },
//   { key:'whatsapp',       label:'WhatsApp',         icon:<IcoWa/>,     get: v => v.whatsappnumber,            editable:false                          },
//   { key:'project',        label:'Project',          icon:<IcoBuild/>,  get: v => v.project?.name,             editable:false                          },
//   { key:'developer',      label:'Developer',        icon:<IcoHammer/>, get: v => v.project?.developer?.name,  editable:false                          },
//   { key:'campaign',       label:'Campaign',         icon:<IcoMega/>,   get: v => v.campaign?.CampainName,     editable:false, isCampaign:true         },
//   { key:'channel',        label:'Channel',          icon:<IcoSignal/>, get: v => v.chanel?.name,              editable:false                          },
//   { key:'communication',  label:'Communication Way',icon:<IcoChat/>,   get: v => v.communicationway?.name,    editable:false                          },
// ];

// /* ════════════════════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ════════════════════════════════════════════════════════════════════════════ */
// export const LeadDuplicationModal = ({ open, onClose, leadId, leadName }) => {
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);

//   // ── confirm state ──────────────────────────────────────────────────────────
//   const [confirmState,   setConfirmState]   = useState(null);
//   // { fieldKey, value, label, submissionIndex }
//   const [confirmLoading, setConfirmLoading] = useState(false);

//   const resselectedlead  = useSelector(s => s.Allusers.Get_users);
//   const leadData         = resselectedlead?.data ?? {};
//   const versions         = leadData?.allVersions || [];
//   const totalSubmissions = leadData?.totalSubmissions || versions.length;

//   const fetchLead = () => {
//     setLoading(true);
//     dispatch(GetOneClientAction(leadId)).finally(() => setLoading(false));
//   };

//   useEffect(() => {
//     if (open && leadId) fetchLead();
//   }, [open, leadId]);

//   // close confirm when clicking outside
//   useEffect(() => {
//     const handler = () => setConfirmState(null);
//     if (confirmState) document.addEventListener('click', handler);
//     return () => document.removeEventListener('click', handler);
//   }, [confirmState]);

//   const sortedVersions  = [...versions].sort((a, b) => new Date(a.recordedAt) - new Date(b.recordedAt));
//   const firstSubmission = sortedVersions[0];
//   const lastSubmission  = sortedVersions[sortedVersions.length - 1];

//   // ── handle + click ─────────────────────────────────────────────────────────
//   const handlePlusClick = (e, field, value, submissionIndex) => {
//     e.stopPropagation();
//     if (!value || !field.fieldKey) return;
//     setConfirmState({
//       fieldKey:        field.fieldKey,
//       value,
//       label:           field.label,
//       submissionIndex,
//     });
//   };

//   // ── confirm update ─────────────────────────────────────────────────────────
//   const handleConfirmUpdate = async () => {
//     if (!confirmState) return;
//     setConfirmLoading(true);
//     try {
//       await dispatch(UpdateClientAction(leadId, { [confirmState.fieldKey]: confirmState.value }));
//       setConfirmState(null);
//       fetchLead();
//     } catch {
//       // silent
//     } finally {
//       setConfirmLoading(false);
//     }
//   };

//   if (!open) return null;

//   return createPortal(
//     <>
//       <style>{STYLES}</style>
//       <div
//         className="ldm-overlay"
//         onClick={e => {
//           if (e.target === e.currentTarget) { setConfirmState(null); onClose(); }
//         }}
//       >
//         <div className="ldm-modal">

//           {/* ── Header ── */}
//           <div className="ldm-header">
//             <div style={{ flex:1 }}>
//               <div className="ldm-audit-label">Audit Registry</div>
//               <h2 className="ldm-title">Duplicated Submissions</h2>
//             </div>
//             <div className="ldm-count-badge">
//               <IcoList />
//               {totalSubmissions} Submission{totalSubmissions !== 1 ? 's' : ''} Found
//             </div>
//             <button className="ldm-close" onClick={() => { setConfirmState(null); onClose(); }}>
//               <IcoClose />
//             </button>
//           </div>

//           {loading ? (
//             <div className="ldm-center">
//               <div className="ldm-spinner" />
//               <span>Loading submissions…</span>
//             </div>
//           ) : versions.length === 0 ? (
//             <div className="ldm-center">
//               <span style={{ fontSize:32 }}>📭</span>
//               <span>No duplicate submissions found for this lead.</span>
//             </div>
//           ) : (
//             <>
//               {/* ── Top Cards ── */}
//               <div className="ldm-cards-row">
//                 <div className="ldm-card first">
//                   <span className="ldm-card-badge original">ORIGINAL</span>
//                   <p className="ldm-card-title">First Registration</p>
//                   <div className="ldm-card-grid">
//                     <div>
//                       <div className="ldm-card-field-label">Created By</div>
//                       <div className="ldm-card-field-value">{firstSubmission?.addby?.name || 'N/A'}</div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">Registry Date</div>
//                       <div className="ldm-card-field-value">
//                         {firstSubmission ? moment(firstSubmission.recordedAt).format('MMM DD, YYYY · hh:mm A') : 'N/A'}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">System Version</div>
//                       <div className="ldm-card-field-value" style={{ color:'#22C55E', fontWeight:700 }}>
//                         #1 of {totalSubmissions}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">Source ID</div>
//                       <div className="ldm-card-field-value" style={{ color:'#64748B' }}>
//                         #{firstSubmission?._id?.slice(-6)?.toUpperCase() || 'N/A'}
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="ldm-card last">
//                   <span className="ldm-card-badge duplicate">DUPLICATE</span>
//                   <p className="ldm-card-title">Last Registration</p>
//                   <div className="ldm-card-grid">
//                     <div>
//                       <div className="ldm-card-field-label">Created By</div>
//                       <div className="ldm-card-field-value">{lastSubmission?.addby?.name || 'N/A'}</div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">Registry Date</div>
//                       <div className="ldm-card-field-value">
//                         {lastSubmission ? moment(lastSubmission.recordedAt).format('MMM DD, YYYY · hh:mm A') : 'N/A'}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">System Version</div>
//                       <div className="ldm-card-field-value" style={{ color:'#F59E0B', fontWeight:700 }}>
//                         #{totalSubmissions} of {totalSubmissions}
//                       </div>
//                     </div>
//                     <div>
//                       <div className="ldm-card-field-label">Source ID</div>
//                       <div className="ldm-card-field-value" style={{ color:'#64748B' }}>
//                         #{lastSubmission?._id?.slice(-6)?.toUpperCase() || 'N/A'}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="ldm-divider" />

//               {/* ── Comparison Table ── */}
//               <div className="ldm-table-section">
//                 <table className="ldm-table">
//                   <thead>
//                     <tr>
//                       <th className="ldm-th attr">Attribute Field</th>
//                       {sortedVersions.map((_, i) => (
//                         <th key={i} className="ldm-th sub">Submission #{i + 1}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {FIELDS.map(field => {
//                       const vals    = sortedVersions.map(v => field.get(v));
//                       const allSame = vals.every(v => v === vals[0]);
//                       return (
//                         <tr key={field.key} className="ldm-tr">
//                           {/* ── Attribute label — بدون + هنا ── */}
//                           <td className="ldm-td">
//                             <div style={{ display:'flex', alignItems:'center', gap:10 }}>
//                               <div className="ldm-td-icon">{field.icon}</div>
//                               <span style={{ fontSize:13, fontWeight:600, color:'#374151' }}>{field.label}</span>
//                             </div>
//                           </td>

//                           {/* ── Values — كل cell فيها + لو editable وعندها قيمة ── */}
//                           {vals.map((val, i) => (
//                             <td key={i} className="ldm-td">
//                               <div style={{ display:'flex', alignItems:'center', gap:6 }}>
//                                 {field.isCampaign && val ? (
//                                   <span className={`ldm-campaign-badge ${i % 2 === 1 ? 'b' : ''}`}>
//                                     {val.toUpperCase()}
//                                   </span>
//                                 ) : (
//                                   <span className={`ldm-td-val ${!val ? 'italic' : ''} ${!allSame ? 'diff' : ''}`}>
//                                     {val || 'Not Specified'}
//                                   </span>
//                                 )}

//                                 {/* ✅ + button — بس لو field editable وعنده قيمة */}
//                                 {field.editable && val && (
//                                   <button
//                                     className="ldm-plus-btn"
//                                     title={`Update lead ${field.label} with "${val}"`}
//                                     onClick={e => handlePlusClick(e, field, val, i + 1)}
//                                   >
//                                     +
//                                   </button>
//                                 )}
//                               </div>
//                             </td>
//                           ))}
//                         </tr>
//                       );
//                     })}

//                     {/* Added By row */}
//                     <tr className="ldm-tr" style={{ background:'#FAFBFF' }}>
//                       <td className="ldm-td">
//                         <div style={{ display:'flex', alignItems:'center', gap:10 }}>
//                           <div className="ldm-td-icon"><IcoUser /></div>
//                           <span style={{ fontSize:13, fontWeight:600, color:'#374151' }}>Added By</span>
//                         </div>
//                       </td>
//                       {sortedVersions.map((ver, i) => (
//                         <td key={i} className="ldm-td">
//                           <span style={{ fontSize:13, fontWeight:600, color:'#4F46E5' }}>
//                             {ver.addby?.name || 'N/A'}
//                           </span>
//                         </td>
//                       ))}
//                     </tr>

//                     {/* Date row */}
//                     <tr className="ldm-tr" style={{ background:'#FAFBFF' }}>
//                       <td className="ldm-td">
//                         <div style={{ display:'flex', alignItems:'center', gap:10 }}>
//                           <div className="ldm-td-icon">
//                             <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                               <rect x="3" y="4" width="18" height="18" rx="2"/>
//                               <line x1="16" y1="2" x2="16" y2="6"/>
//                               <line x1="8" y1="2" x2="8" y2="6"/>
//                               <line x1="3" y1="10" x2="21" y2="10"/>
//                             </svg>
//                           </div>
//                           <span style={{ fontSize:13, fontWeight:600, color:'#374151' }}>Recorded At</span>
//                         </div>
//                       </td>
//                       {sortedVersions.map((ver, i) => (
//                         <td key={i} className="ldm-td">
//                           <span style={{ fontSize:13, color:'#64748B' }}>
//                             {ver.recordedAt ? moment(ver.recordedAt).format('DD MMM YYYY, HH:mm') : 'N/A'}
//                           </span>
//                         </td>
//                       ))}
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               {/* ── Footer ── */}
//               <div className="ldm-footer">
//                 <button
//                   className="ldm-btn-ignore"
//                   onClick={() => { setConfirmState(null); onClose(); }}
//                 >
//                   Close
//                 </button>
//               </div>
//             </>
//           )}
//         </div>

//         {/* ── Confirmation Popup — خارج الـ modal div عشان الـ z-index ── */}
//         {confirmState && (
//           <div
//             className="ldm-edit-popup"
//             style={{
//               top:       '50%',
//               left:      '50%',
//               transform: 'translate(-50%, -50%)',
//               minWidth:  320,
//             }}
//             onClick={e => e.stopPropagation()}
//           >
//             {/* Header */}
//             <div className="ldm-edit-popup-title">Confirm Update</div>

//             {/* Info */}
//             <p style={{ fontSize:13, color:'#64748B', margin:'0 0 8px', fontFamily:"'DM Sans',sans-serif" }}>
//               Update lead's <strong style={{ color:'#0F172A' }}>{confirmState.label}</strong> from Submission #{confirmState.submissionIndex} to:
//             </p>

//             {/* Value preview */}
//             <div style={{
//               padding:     '10px 14px',
//               background:  '#F1F5F9',
//               borderRadius: 8,
//               fontSize:    14,
//               fontWeight:  700,
//               color:       '#0F172A',
//               fontFamily:  "'DM Sans',sans-serif",
//               marginBottom: 4,
//               wordBreak:   'break-all',
//             }}>
//               {confirmState.value}
//             </div>

//             <p style={{ fontSize:11, color:'#94A3B8', margin:'6px 0 0', fontFamily:"'DM Sans',sans-serif" }}>
//               This will overwrite the current {confirmState.label.toLowerCase()} on the lead.
//             </p>

//             {/* Actions */}
//             <div className="ldm-edit-actions">
//               <button
//                 className="ldm-edit-cancel"
//                 onClick={() => setConfirmState(null)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="ldm-edit-save"
//                 onClick={handleConfirmUpdate}
//                 disabled={confirmLoading}
//               >
//                 {confirmLoading && <div className="ldm-spinner-sm" />}
//                 {confirmLoading ? 'Updating…' : 'Confirm Update'}
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </>,
//     document.body
//   );
// };


























import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetOneClientAction, UpdateClientAction } from '../Redux/Actions/UsersAction';
import moment from 'moment';
import { ShowClientsActionsAdvanced } from './ShowClientsActionsAdvanced';
import { AssignLeadsModal } from './AssignLeadsModal';

/* ─── inline CSS ─────────────────────────────────────────────────────────── */
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');

  @keyframes ldm-in {
    from { opacity:0; transform:translateY(18px) scale(0.98); }
    to   { opacity:1; transform:none; }
  }
  @keyframes ldm-spin { to { transform:rotate(360deg); } }

  .ldm-overlay {
    position:fixed; inset:0; z-index:99999;
    display:flex; align-items:center; justify-content:center;
    background:rgba(15,23,42,0.5);
    backdrop-filter:blur(6px);
    padding:20px;
    font-family:'DM Sans',sans-serif;
  }

  .ldm-modal {
    background:#F8FAFC;
    border-radius:16px;
    width:100%; max-width:900px;
    max-height:92vh;
    overflow:hidden;
    display:flex; flex-direction:column;
    box-shadow:0 32px 80px rgba(0,0,0,0.2);
    animation:ldm-in 0.3s cubic-bezier(0.34,1.1,0.64,1) both;
    border:1px solid #E2E8F0;
  }

  .ldm-header {
    background:#fff;
    padding:20px 28px 18px;
    border-bottom:1px solid #E9EEF5;
    flex-shrink:0;
    display:flex; align-items:flex-start; justify-content:space-between;
  }
  .ldm-audit-label {
    font-size:10px; font-weight:700; letter-spacing:0.12em;
    color:#94A3B8; text-transform:uppercase; margin-bottom:4px;
  }
  .ldm-title {
    font-size:24px; font-weight:800; color:#0F172A;
    letter-spacing:-0.4px; margin:0;
  }
  .ldm-count-badge {
    display:flex; align-items:center; gap:7px;
    background:#F1F5F9; border:1.5px solid #E2E8F0;
    padding:8px 14px; border-radius:10px;
    font-size:13px; font-weight:700; color:#475569;
    flex-shrink:0;
  }
  .ldm-close {
    width:34px; height:34px; border-radius:8px;
    border:1.5px solid #E2E8F0; background:#F8FAFC;
    display:flex; align-items:center; justify-content:center;
    cursor:pointer; color:#64748B; margin-left:12px;
    transition:all 0.15s; flex-shrink:0;
  }
  .ldm-close:hover { background:#F1F5F9; color:#0F172A; }

  /* ── all comments button ── */
  .ldm-comments-btn {
    display:flex; align-items:center; gap:7px;
    background:#fff; border:1.5px solid #E2E8F0;
    padding:8px 14px; border-radius:10px;
    font-family:'DM Sans',sans-serif;
    font-size:13px; font-weight:700; color:#1E3A8A;
    cursor:pointer; transition:all 0.15s; flex-shrink:0; margin-left:12px;
  }
  .ldm-comments-btn:hover { background:#EFF6FF; border-color:#1E3A8A; }

  .ldm-cards-row {
    display:grid; grid-template-columns:1fr 1fr; gap:16px;
    padding:20px 28px 0; flex-shrink:0;
  }
  .ldm-card {
    background:#fff; border-radius:12px;
    border:1.5px solid #E2E8F0;
    padding:18px 20px;
    position:relative; overflow:hidden;
  }
  .ldm-card.first { border-left:4px solid #22C55E; }
  .ldm-card.last  { border-left:4px solid #F59E0B; }

  .ldm-card-badge {
    position:absolute; top:14px; right:14px;
    padding:3px 10px; border-radius:20px;
    font-size:10px; font-weight:700; letter-spacing:0.08em;
  }
  .ldm-card-badge.original  { background:#DCFCE7; color:#16A34A; }
  .ldm-card-badge.duplicate { background:#FEF3C7; color:#D97706; }

  .ldm-card-title {
    font-size:15px; font-weight:700; color:#0F172A; margin:0 0 14px;
  }
  .ldm-card-grid {
    display:grid; grid-template-columns:1fr 1fr; gap:10px 20px;
  }
  .ldm-card-field-label {
    font-size:10px; font-weight:700; letter-spacing:0.08em;
    color:#94A3B8; text-transform:uppercase; margin-bottom:3px;
  }
  .ldm-card-field-value {
    font-size:13px; font-weight:600; color:#1E293B;
  }

  .ldm-divider { height:1px; background:#E9EEF5; margin:20px 28px 0; flex-shrink:0; }

  .ldm-table-section {
    flex:1; overflow-y:auto; padding:0 28px 24px;
    scrollbar-width:thin; scrollbar-color:#CBD5E1 transparent;
  }
  .ldm-table-section::-webkit-scrollbar { width:5px; }
  .ldm-table-section::-webkit-scrollbar-thumb { background:#CBD5E1; border-radius:4px; }

  .ldm-table {
    width:100%; border-collapse:collapse; margin-top:20px;
    background:#fff; border-radius:12px; overflow:hidden;
    border:1.5px solid #E2E8F0;
  }

  .ldm-table thead tr {
    background:#F8FAFC;
    border-bottom:1.5px solid #E2E8F0;
  }
  .ldm-th {
    padding:11px 16px; text-align:left;
    font-size:10.5px; font-weight:700; letter-spacing:0.08em;
    text-transform:uppercase; white-space:nowrap;
  }
  .ldm-th.attr  { color:#94A3B8; width:160px; }
  .ldm-th.sub   { color:#4F46E5; }

  .ldm-tr { border-bottom:1px solid #F1F5F9; transition:background 0.1s; }
  .ldm-tr:last-child { border-bottom:none; }
  .ldm-tr:hover { background:#FAFBFF; }

  .ldm-td {
    padding:13px 16px; vertical-align:middle;
  }
  .ldm-td-icon {
    width:28px; height:28px; border-radius:7px;
    background:#F1F5F9; display:flex; align-items:center;
    justify-content:center; flex-shrink:0; color:#64748B;
  }
  .ldm-td-val {
    font-size:13px; color:#0F172A; font-weight:400;
  }
  .ldm-td-val.italic { color:#64748B; font-style:italic; }
  .ldm-td-val.diff   { font-weight:600; }

  .ldm-campaign-badge {
    display:inline-block; padding:3px 10px; border-radius:20px;
    font-size:11px; font-weight:700; letter-spacing:0.04em;
    background:#EDE9FE; color:#7C3AED;
  }
  .ldm-campaign-badge.b { background:#DBEAFE; color:#1D4ED8; }

  /* ── checkbox (custom) ── */
  .ldm-check {
    width:18px; height:18px; border-radius:5px;
    border:1.5px solid #CBD5E1; background:#fff;
    display:inline-flex; align-items:center; justify-content:center;
    cursor:pointer; flex-shrink:0; margin-left:8px;
    transition:all 0.15s; position:relative; vertical-align:middle;
  }
  .ldm-check:hover { border-color:#3B82F6; }
  .ldm-check.checked {
    background:#1E3A8A; border-color:#1E3A8A;
  }
  .ldm-check.checked svg { display:block; }
  .ldm-check svg { display:none; color:#fff; }

  /* highlight selected cell */
  .ldm-cell-selected {
    background:#EFF6FF;
    border-radius:8px;
    margin:-6px -8px;
    padding:6px 8px;
  }

  /* ── selection summary badge in header ── */
  .ldm-selected-badge {
    display:flex; align-items:center; gap:6px;
    background:#1E3A8A; color:#fff;
    padding:8px 14px; border-radius:10px;
    font-size:13px; font-weight:700;
  }

  /* ── merge confirm popup ── */
  .ldm-edit-popup {
    position:fixed; z-index:100000;
    background:#fff; border-radius:12px;
    border:1.5px solid #E2E8F0;
    box-shadow:0 8px 32px rgba(0,0,0,0.15);
    padding:18px 20px;
    min-width:340px;
    max-width:420px;
    animation:ldm-in 0.2s ease both;
  }
  .ldm-edit-popup-title {
    font-size:11px; font-weight:700; letter-spacing:0.08em;
    color:#64748B; text-transform:uppercase; margin-bottom:12px;
  }
  .ldm-merge-row {
    display:flex; justify-content:space-between; align-items:baseline;
    padding:8px 0; border-bottom:1px solid #F1F5F9; gap:12px;
  }
  .ldm-merge-row:last-of-type { border-bottom:none; }
  .ldm-merge-row-label {
    font-size:11px; font-weight:700; color:#94A3B8;
    text-transform:uppercase; letter-spacing:0.05em; flex-shrink:0;
  }
  .ldm-merge-row-val {
    font-size:13px; font-weight:600; color:#0F172A;
    text-align:right; word-break:break-word;
  }
  .ldm-edit-actions {
    display:flex; gap:8px; margin-top:14px; justify-content:flex-end;
  }
  .ldm-edit-cancel {
    padding:6px 14px; border-radius:7px;
    border:1.5px solid #E2E8F0; background:#fff;
    font-family:'DM Sans',sans-serif; font-size:12px; font-weight:600;
    color:#64748B; cursor:pointer;
  }
  .ldm-edit-save {
    padding:6px 16px; border-radius:7px; border:none;
    background:#1E3A8A; color:#fff;
    font-family:'DM Sans',sans-serif; font-size:12px; font-weight:700;
    cursor:pointer; transition:background 0.15s;
    display:flex; align-items:center; gap:6px;
  }
  .ldm-edit-save:hover { background:#1E40AF; }
  .ldm-edit-save:disabled { opacity:0.55; cursor:not-allowed; }
  .ldm-spinner-sm {
    width:12px; height:12px; border:2px solid rgba(255,255,255,0.3);
    border-top-color:#fff; border-radius:50%;
    animation:ldm-spin 0.7s linear infinite;
  }

  .ldm-footer {
    padding:14px 28px; border-top:1px solid #E9EEF5;
    display:flex; align-items:center; justify-content:space-between;
    gap:10px; flex-shrink:0; background:#fff;
  }
  .ldm-footer-left {
    font-size:12px; color:#94A3B8; font-weight:600;
  }
  .ldm-footer-left strong { color:#1E3A8A; }
  .ldm-btn-ignore {
    padding:10px 22px; border-radius:10px;
    border:1.5px solid #E2E8F0; background:#fff;
    font-family:'DM Sans',sans-serif; font-size:14px; font-weight:600;
    color:#64748B; cursor:pointer; transition:all 0.15s;
  }
  .ldm-btn-ignore:hover { background:#F8FAFC; border-color:#CBD5E1; color:#0F172A; }
  .ldm-btn-merge {
    padding:10px 24px; border-radius:10px; border:none;
    background:#1E3A8A; color:#fff;
    font-family:'DM Sans',sans-serif; font-size:14px; font-weight:700;
    cursor:pointer; transition:background 0.15s;
    display:flex; align-items:center; gap:8px;
  }
  .ldm-btn-merge:hover { background:#1E40AF; }
  .ldm-btn-merge:disabled { opacity:0.4; cursor:not-allowed; background:#94A3B8; }

  .ldm-center {
    display:flex; flex-direction:column; align-items:center;
    justify-content:center; padding:60px 20px;
    color:#94A3B8; font-size:14px; gap:12px;
  }
  .ldm-spinner {
    width:36px; height:36px; border:3px solid #E2E8F0;
    border-top-color:#4F46E5; border-radius:50%;
    animation:ldm-spin 0.7s linear infinite;
  }
`;

/* ─── icons ──────────────────────────────────────────────────────────────── */
const IcoClose  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoList   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;
const IcoUser   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IcoMail   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const IcoPhone  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.07 6.07l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcoWa     = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/></svg>;
const IcoBuild  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9.5L12 3l9 6.5V21H3V9.5z"/><rect x="9" y="14" width="6" height="7" rx="1"/></svg>;
const IcoHammer = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15.2 2.8L21 8.6l-9 9-5.8-5.8z"/><path d="M6.5 17.5l-4 4"/><path d="M2 12l5-5"/></svg>;
const IcoMega   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>;
const IcoSignal = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="1" y1="6" x2="1" y2="18"/><line x1="6" y1="3" x2="6" y2="18"/><line x1="11" y1="8" x2="11" y2="18"/><line x1="16" y1="5" x2="16" y2="18"/></svg>;
const IcoChat   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IcoCalendar = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IcoCheck  = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoMerge  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 3v12a3 3 0 0 0 3 3h6"/><path d="M18 3v6"/><path d="M15 6l3-3 3 3"/></svg>;
const IcoComments = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IcoAssign = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>;

/* ─── field config ────────────────────────────────────────────────────────────
 *
 *  editable:   true  → يظهر checkbox جنب كل قيمة
 *  fieldKey:   الـ key اللي هيتبعت في الـ API body
 *  getIdVal:   لو الـ field بيحتاج ObjectId → بنجيب الـ _id من الـ version object
 *              لو مش موجودة → بنبعت الـ display value عادي (زي name/email/phone)
 * ─────────────────────────────────────────────────────────────────────────── */
const FIELDS = [
  { key:'name',          label:'Name',              icon:<IcoUser/>,     get: v => v.name,                      editable:true, fieldKey:'name' },
  { key:'email',         label:'Email',              icon:<IcoMail/>,     get: v => v.email,                     editable:true, fieldKey:'email' },
  { key:'phone',         label:'Phone',              icon:<IcoPhone/>,    get: v => v.phone,                     editable:true, fieldKey:'phone' },
  { key:'whatsapp',      label:'WhatsApp',           icon:<IcoWa/>,       get: v => v.whatsappnumber,            editable:false },
  { key:'project',       label:'Project',            icon:<IcoBuild/>,    get: v => v.project?.name,             getIdVal: v => v.project?._id,             editable:true, fieldKey:'project' },
  { key:'developer',     label:'Developer',          icon:<IcoHammer/>,   get: v => v.project?.developer?.name,  editable:false },
  { key:'campaign',      label:'Campaign',            icon:<IcoMega/>,     get: v => v.campaign?.CampainName,     getIdVal: v => v.campaign?._id,            editable:true, fieldKey:'campaign', isCampaign:true },
  { key:'channel',       label:'Channel',             icon:<IcoSignal/>,   get: v => v.chanel?.name,              getIdVal: v => v.chanel?._id,              editable:true, fieldKey:'chanel' },
  { key:'communication', label:'Communication Way',  icon:<IcoChat/>,     get: v => v.communicationway?.name,    getIdVal: v => v.communicationway?._id,    editable:true, fieldKey:'communicationway' },
  { key:'date',          label:'Recorded At',         icon:<IcoCalendar/>, get: v => v.recordedAt ? moment(v.recordedAt).format('DD MMM YYYY, HH:mm') : null, getIdVal: v => v.recordedAt, editable:true, fieldKey:'date' },
];

/* ════════════════════════════════════════════════════════════════════════════
   MAIN COMPONENT
════════════════════════════════════════════════════════════════════════════ */
export const LeadDuplicationModal = ({ open, onClose, leadId, leadName }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // ── selections: { [fieldKey]: { value, displayValue, label, submissionIndex } }
  const [selections, setSelections] = useState({});
  const [showMergeConfirm, setShowMergeConfirm] = useState(false);
  const [mergeLoading, setMergeLoading] = useState(false);
  const [showAllComments, setShowAllComments] = useState(false);

  const resselectedlead  = useSelector(s => s.Allusers.Get_users);
  const leadData         = resselectedlead?.data ?? {};
  const versions         = leadData?.allVersions || [];
  const totalSubmissions = leadData?.totalSubmissions || versions.length;
const [showAssignModal, setShowAssignModal] = useState(false);

  const fetchLead = () => {
    setLoading(true);
    dispatch(GetOneClientAction(leadId)).finally(() => setLoading(false));
  };

  useEffect(() => {
    if (open && leadId) {
      fetchLead();
      setSelections({});
      setShowMergeConfirm(false);
    }
  }, [open, leadId]);

  const sortedVersions  = [...versions].sort((a, b) => new Date(a.recordedAt) - new Date(b.recordedAt));
  const firstSubmission = sortedVersions[0];
  const lastSubmission  = sortedVersions[sortedVersions.length - 1];

  const selectedCount = Object.keys(selections).length;

  /* ── toggle checkbox ──────────────────────────────────────────────────────
   *  لو نفس الـ field متعلم من submission تانية، التعليم الجديد يبدّل القديم
   *  (مينفعش تختار قيمتين مختلفين لنفس الحقل في نفس الوقت)
   * ─────────────────────────────────────────────────────────────────────── */
  const toggleSelection = (field, displayVal, apiVal, submissionIndex) => {
    setSelections(prev => {
      const existing = prev[field.fieldKey];
      const isSameCell = existing && existing.submissionIndex === submissionIndex;

      // لو نفس الخلية متعلمة → فك التعليم
      if (isSameCell) {
        const next = { ...prev };
        delete next[field.fieldKey];
        return next;
      }

      // غير ذلك → اختار الخلية دي (وتبدّل أي اختيار سابق لنفس الحقل)
      return {
        ...prev,
        [field.fieldKey]: {
          value: apiVal,
          displayValue: displayVal,
          label: field.label,
          submissionIndex,
        },
      };
    });
  };

  const isCellChecked = (fieldKey, submissionIndex) =>
    selections[fieldKey]?.submissionIndex === submissionIndex;

  /* ── confirm merge ────────────────────────────────────────────────────── */
  const handleMergeConfirm = async () => {
    if (selectedCount === 0) return;
    setMergeLoading(true);
    try {
      const payload = {};
      Object.entries(selections).forEach(([fieldKey, sel]) => {
        payload[fieldKey] = sel.value;
      });
      console.log('[LeadDuplicationModal] merge payload →', payload); // TODO: remove after debugging
      await dispatch(UpdateClientAction(leadId, payload));
      setSelections({});
      setShowMergeConfirm(false);
      fetchLead();
    } catch {
      // silent
    } finally {
      setMergeLoading(false);
    }
  };

  if (!open) return null;

  return createPortal(
    <>
      <style>{STYLES}</style>
      <div
        className="ldm-overlay"
        onClick={e => {
          if (e.target === e.currentTarget) { setShowMergeConfirm(false); onClose(); }
        }}
      >
        <div className="ldm-modal">

          {/* ── Header ── */}
          <div className="ldm-header">
            <div style={{ flex:1 }}>
              <div className="ldm-audit-label">Audit Registry</div>
              <h2 className="ldm-title">Duplicated Submissions</h2>
            </div>
            {selectedCount > 0 ? (
              <div className="ldm-selected-badge">
                <IcoCheck />
                {selectedCount} Field{selectedCount !== 1 ? 's' : ''} Selected
              </div>
            ) : (
              <div className="ldm-count-badge">
                <IcoList />
                {totalSubmissions} Submission{totalSubmissions !== 1 ? 's' : ''} Found
              </div>
            )}
            <button className="ldm-comments-btn" onClick={() => setShowAllComments(true)}>
              <IcoComments />
              All Comments
            </button>

            <button className="ldm-comments-btn" onClick={() => setShowAssignModal(true)}>
  <IcoAssign />
  Lead Assign
</button>
            <button className="ldm-close" onClick={() => { setShowMergeConfirm(false); onClose(); }}>
              <IcoClose />
            </button>
          </div>

          {loading ? (
            <div className="ldm-center">
              <div className="ldm-spinner" />
              <span>Loading submissions…</span>
            </div>
          ) : versions.length === 0 ? (
            <div className="ldm-center">
              <span style={{ fontSize:32 }}>📭</span>
              <span>No duplicate submissions found for this lead.</span>
            </div>
          ) : (
            <>
              {/* ── Top Cards ── */}
              <div className="ldm-cards-row">
                <div className="ldm-card first">
                  <span className="ldm-card-badge original">ORIGINAL</span>
                  <p className="ldm-card-title">First Registration</p>
                  <div className="ldm-card-grid">
                    <div>
                      <div className="ldm-card-field-label">Created By</div>
                      <div className="ldm-card-field-value">{firstSubmission?.addby?.name || 'N/A'}</div>
                    </div>
                    <div>
                      <div className="ldm-card-field-label">Registry Date</div>
                      <div className="ldm-card-field-value">
                        {firstSubmission ? moment(firstSubmission.recordedAt).format('MMM DD, YYYY · hh:mm A') : 'N/A'}
                      </div>
                    </div>
                    <div>
                      <div className="ldm-card-field-label">System Version</div>
                      <div className="ldm-card-field-value" style={{ color:'#22C55E', fontWeight:700 }}>
                        #1 of {totalSubmissions}
                      </div>
                    </div>
                    <div>
                      <div className="ldm-card-field-label">Source ID</div>
                      <div className="ldm-card-field-value" style={{ color:'#64748B' }}>
                        #{firstSubmission?._id?.slice(-6)?.toUpperCase() || 'N/A'}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="ldm-card last">
                  <span className="ldm-card-badge duplicate">DUPLICATE</span>
                  <p className="ldm-card-title">Last Registration</p>
                  <div className="ldm-card-grid">
                    <div>
                      <div className="ldm-card-field-label">Created By</div>
                      <div className="ldm-card-field-value">{lastSubmission?.addby?.name || 'N/A'}</div>
                    </div>
                    <div>
                      <div className="ldm-card-field-label">Registry Date</div>
                      <div className="ldm-card-field-value">
                        {lastSubmission ? moment(lastSubmission.recordedAt).format('MMM DD, YYYY · hh:mm A') : 'N/A'}
                      </div>
                    </div>
                    <div>
                      <div className="ldm-card-field-label">System Version</div>
                      <div className="ldm-card-field-value" style={{ color:'#F59E0B', fontWeight:700 }}>
                        #{totalSubmissions} of {totalSubmissions}
                      </div>
                    </div>
                    <div>
                      <div className="ldm-card-field-label">Source ID</div>
                      <div className="ldm-card-field-value" style={{ color:'#64748B' }}>
                        #{lastSubmission?._id?.slice(-6)?.toUpperCase() || 'N/A'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="ldm-divider" />

              {/* ── Comparison Table ── */}
              <div className="ldm-table-section">
                <table className="ldm-table">
                  <thead>
                    <tr>
                      <th className="ldm-th attr">Attribute Field</th>
                      {sortedVersions.map((_, i) => (
                        <th key={i} className="ldm-th sub">Submission #{i + 1}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {FIELDS.map(field => {
                      const displayVals = sortedVersions.map(v => field.get(v));
                      const allSame     = displayVals.every(v => v === displayVals[0]);

                      return (
                        <tr key={field.key} className="ldm-tr">
                          {/* Attribute label */}
                          <td className="ldm-td">
                            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                              <div className="ldm-td-icon">{field.icon}</div>
                              <span style={{ fontSize:13, fontWeight:600, color:'#374151' }}>{field.label}</span>
                            </div>
                          </td>

                          {/* Values per submission */}
                          {displayVals.map((displayVal, i) => {
                            const apiVal = field.getIdVal
                              ? field.getIdVal(sortedVersions[i])
                              : displayVal;
                            const submissionIndex = i + 1;
                            const checked = isCellChecked(field.fieldKey, submissionIndex);

                            return (
                              <td key={i} className="ldm-td">
                                <div className={checked ? 'ldm-cell-selected' : ''} style={{ display:'flex', alignItems:'center', gap:6 }}>
                                  {field.isCampaign && displayVal ? (
                                    <span className={`ldm-campaign-badge ${i % 2 === 1 ? 'b' : ''}`}>
                                      {displayVal.toUpperCase()}
                                    </span>
                                  ) : (
                                    <span className={`ldm-td-val ${!displayVal ? 'italic' : ''} ${!allSame ? 'diff' : ''}`}>
                                      {displayVal || 'Not Specified'}
                                    </span>
                                  )}

                                  {/* checkbox — بس لو editable وعنده apiVal حقيقية */}
                                  {field.editable && apiVal && (
                                    <span
                                      className={`ldm-check ${checked ? 'checked' : ''}`}
                                      title={checked ? 'Unselect' : `Select to merge into lead`}
                                      onClick={() => toggleSelection(field, displayVal, apiVal, submissionIndex)}
                                    >
                                      <IcoCheck />
                                    </span>
                                  )}
                                </div>
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}

                    {/* Added By row */}
                    <tr className="ldm-tr" style={{ background:'#FAFBFF' }}>
                      <td className="ldm-td">
                        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                          <div className="ldm-td-icon"><IcoUser /></div>
                          <span style={{ fontSize:13, fontWeight:600, color:'#374151' }}>Added By</span>
                        </div>
                      </td>
                      {sortedVersions.map((ver, i) => (
                        <td key={i} className="ldm-td">
                          <span style={{ fontSize:13, fontWeight:600, color:'#4F46E5' }}>
                            {ver.addby?.name || 'N/A'}
                          </span>
                        </td>
                      ))}
                    </tr>

                  </tbody>
                </table>
              </div>

              {/* ── Footer ── */}
              <div className="ldm-footer">
                <div className="ldm-footer-left">
                  {selectedCount > 0
                    ? <>Ready to merge <strong>{selectedCount}</strong> field{selectedCount !== 1 ? 's' : ''} into the lead</>
                    : 'Select fields using the checkboxes to merge into the lead'}
                </div>
                <div style={{ display:'flex', gap:10 }}>
                  <button
                    className="ldm-btn-ignore"
                    onClick={() => { setShowMergeConfirm(false); onClose(); }}
                  >
                    Close
                  </button>
                  <button
                    className="ldm-btn-merge"
                    disabled={selectedCount === 0}
                    onClick={() => setShowMergeConfirm(true)}
                  >
                    <IcoMerge />
                    Merge ({selectedCount})
                  </button>
                </div>
              </div>
            </>
          )}
        </div>

        {/* ── Merge Confirmation Popup ── */}
        {showMergeConfirm && (
          <div
            className="ldm-edit-popup"
            style={{
              top:       '50%',
              left:      '50%',
              transform: 'translate(-50%, -50%)',
            }}
            onClick={e => e.stopPropagation()}
          >
            <div className="ldm-edit-popup-title">Confirm Merge</div>

            <p style={{ fontSize:13, color:'#64748B', margin:'0 0 10px', fontFamily:"'DM Sans',sans-serif" }}>
              The following fields will be updated on the lead:
            </p>

            <div>
              {Object.entries(selections).map(([fieldKey, sel]) => (
                <div key={fieldKey} className="ldm-merge-row">
                  <span className="ldm-merge-row-label">
                    {sel.label} <span style={{ color:'#CBD5E1' }}>(#{sel.submissionIndex})</span>
                  </span>
                  <span className="ldm-merge-row-val">{sel.displayValue}</span>
                </div>
              ))}
            </div>

            <p style={{ fontSize:11, color:'#94A3B8', margin:'10px 0 0', fontFamily:"'DM Sans',sans-serif" }}>
              This will overwrite the current values on the lead with the ones above.
            </p>

            <div className="ldm-edit-actions">
              <button className="ldm-edit-cancel" onClick={() => setShowMergeConfirm(false)}>
                Cancel
              </button>
              <button
                className="ldm-edit-save"
                onClick={handleMergeConfirm}
                disabled={mergeLoading}
              >
                {mergeLoading && <div className="ldm-spinner-sm" />}
                {mergeLoading ? 'Merging…' : 'Confirm Merge'}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ── All Comments (ShowClientsActionsAdvanced) ── */}
      {showAllComments && (
        <ShowClientsActionsAdvanced
          user={leadData}
          leadid={leadId}
          onClose={() => setShowAllComments(false)}
          onLeadUpdated={fetchLead}
        />
      )}

{/* ── Lead Assign ── */}
{showAssignModal && (
  <AssignLeadsModal
    show={showAssignModal}
    onHide={() => setShowAssignModal(false)}
    selectedLeads={[leadId]}
    refreshData={fetchLead}
  />
)}


      
    </>,
    document.body
  );
};